<div class="control-panel-container">
  @if (isEvent() || isCardPage() || isPlaylistPage()) {
    <div class="control-panel__description">
      <div class="description-remaining-tickets-box">
        @if (isEvent()) {
          <span class="body-s description">
            {{ 'translations.membersNew.controlPanel.pageDescriptionEvent' | transloco }}
          </span>
        }
        @if ((isCardPage() || isPlaylistPage()) && !isEvent()) {
          <div class="description">
            <span class="body-s">
              {{ 'translations.membersNew.controlPanel.pageDescriptionCardPlaylist.first' | transloco }}
            </span>
            <span class="body-s bold">
              {{ 'translations.membersNew.controlPanel.pageDescriptionCardPlaylist.second' | transloco }}
            </span>
            <span class="body-s">
              {{ 'translations.membersNew.controlPanel.pageDescriptionCardPlaylist.third' | transloco }}
            </span>
            <span class="body-s bold">
              {{ 'translations.membersNew.controlPanel.pageDescriptionCardPlaylist.fourth' | transloco }}
            </span>
            <span class="body-s">
              {{ 'translations.membersNew.controlPanel.pageDescriptionCardPlaylist.fifth' | transloco }}
            </span>
            <span class="body-s bold">
              {{ 'translations.membersNew.controlPanel.pageDescriptionCardPlaylist.sixth' | transloco }}
            </span>
            <span class="body-s">
              {{ 'translations.membersNew.controlPanel.pageDescriptionCardPlaylist.seventh' | transloco }}
            </span>
          </div>
        }
        @if (limitedTickets) {
          <div class="remaining-tickets-count">
            <span class="body-s bold" [class]="remainingTicketsInfoClass"> {{ getRemainingTickets() }} / </span>
            <span class="body-s">
              {{ 'translations.membersNew.controlPanel.ticketsLeft' | transloco: { ticketsQuantity: ticketsQuantity } }}
            </span>
          </div>
        }
      </div>
    </div>
  }

  <div class="members-toolbar">
    <div class="toolbar-row">
      <ptl-sg-input
        class="search-input"
        [withIcon]="true"
        [icon]="LucideSearch"
        type="text"
        [formControl]="searchControl"
        [placeholder]="'translations.content.label.searchByName' | transloco"
      ></ptl-sg-input>

      <mat-menu #exportMenu>
        <button mat-menu-item (click)="exportUsersButtonClicked()">
          <span class="body-s">{{ 'translations.members.button.exportCsv' | transloco }}</span>
        </button>
        <mat-divider></mat-divider>
        <button mat-menu-item (click)="openAdvancedExport()">
          <span class="body-s">{{ 'translations.advancedExport.title.main' | transloco }}</span>
        </button>
      </mat-menu>

      <ptl-button
        [type]="'secondary-neutral'"
        [icon]="LucideFunnel"
        [text]="'translations.global.button.filter' | transloco"
        [matMenuTriggerFor]="filterMenu"
      ></ptl-button>
      <mat-menu #filterMenu>
        @for (label of filterLabels; track label.type) {
          <button mat-menu-item class="body-s" (click)="filterSelected(label.type)">{{ label.value }}</button>
        }
      </mat-menu>

      @if (!isIframeMode) {
        @if (exportEnabled() && !advancedExportAvailable) {
          <ptl-button
            [type]="'secondary-neutral'"
            [icon]="LucideDownload"
            (clicked)="exportUsersButtonClicked()"
            [attr.aria-label]="'translations.global.ariaLabels.exportUsers' | transloco"
          >
            {{ 'translations.membersNew.controlPanel.export' | transloco }}
          </ptl-button>
        }
        @if (exportEnabled() && advancedExportAvailable) {
          <ptl-button
            [type]="'secondary-neutral'"
            [icon]="LucideDownload"
            [matMenuTriggerFor]="exportMenu"
            [attr.aria-label]="'translations.global.ariaLabels.export' | transloco"
          >
            {{ 'translations.membersNew.controlPanel.export' | transloco }}
          </ptl-button>
        }

        @if (isEvent() || isCardPage() || isPlaylistPage()) {
          <ptl-button
            [type]="'secondary-neutral'"
            [icon]="LucideUpload"
            [disabled]="isImportDisabled"
            [matTooltip]="importDisabledTooltipText"
            matTooltipClass="medium-tooltip"
            (clicked)="importUsersCsv()"
          >
            {{ 'translations.membersNew.controlPanel.import.name' | transloco }}
          </ptl-button>
        }
      }
      @if (exportEnabled() && isIframeMode) {
        <ptl-button
          [type]="'secondary-neutral'"
          [icon]="LucideDownload"
          (clicked)="exportUsersFilteredByGroup()"
          [attr.aria-label]="'translations.global.ariaLabels.exportUsers' | transloco"
        >
          {{ 'translations.membersNew.controlPanel.export' | transloco }}
        </ptl-button>
      }
    </div>

    <div class="filter-chips-list">
      @for (filter of filters; track filter.type) {
        <div class="filter-chip-wrapper">
          <ptl-base-badge
            [text]="filter.message"
            [color]="'blue'"
            [iconSuffix]="LucideX"
            [matTooltip]="filter.message"
            (clicked)="filterSelected(filter.type)"
            (iconClick)="onRemoveFilter(filter.type)"
          ></ptl-base-badge>
          @if (currentFilter === filter.type) {
            @switch (filter.type) {
              @case ('REVIEW_STATUS') {
                <ptl-review-status-filter
                  class="filter-panel"
                  (filterDeleted)="onRemoveFilter('REVIEW_STATUS')"
                  (filterSaved)="onSaveFilter($event)"
                  [selectedFilters]="filters"
                ></ptl-review-status-filter>
              }
              @case ('GROUP') {
                <ptl-group-filter
                  class="filter-panel"
                  (filterDeleted)="onRemoveFilter('GROUP')"
                  (filterSaved)="onSaveFilter($event)"
                  [selectedFilters]="filters"
                  [playlistUid]="!isAdminPage() ? playlistUid() : undefined"
                ></ptl-group-filter>
              }
              @case ('ROLE') {
                <ptl-role-filter
                  class="filter-panel"
                  (filterDeleted)="onRemoveFilter('ROLE')"
                  (filterSaved)="onSaveFilter($event)"
                  [selectedFilters]="filters"
                ></ptl-role-filter>
              }
              @case ('ATTENDANCE') {
                <ptl-attendance-filter
                  class="filter-panel"
                  (filterDeleted)="onRemoveFilter('ATTENDANCE')"
                  (filterSaved)="onSaveFilter($event)"
                  [selectedFilters]="filters"
                  [isPlaylistPageAndTicketExist]="isPlaylistPage() && isTicketExist"
                ></ptl-attendance-filter>
              }
              @case ('ACTIVITY') {
                <ptl-activity-date-filter
                  class="filter-panel"
                  (filterDeleted)="onRemoveFilter('ACTIVITY')"
                  (filterSaved)="onSaveFilter($event)"
                  [selectedFilters]="filters"
                ></ptl-activity-date-filter>
              }
              @case ('COMPLETION') {
                <ptl-completion-filter
                  class="filter-panel"
                  (filterDeleted)="onRemoveFilter('COMPLETION')"
                  (filterSaved)="onSaveFilter($event)"
                  [selectedFilters]="filters"
                  [isPlaylistPage]="isPlaylistPage()"
                  [playlistUid]="playlistUid()"
                  [isCardPage]="isCardPage()"
                  [cardUid]="cardUid()"
                  [cardHeaders]="cardHeaders()"
                  [formHeaders]="formHeaders()"
                ></ptl-completion-filter>
              }
            }
          }
        </div>
      }

      @if (newFilter) {
        <div class="filter-chip-wrapper">
          @switch (newFilter) {
            @case ('GROUP') {
              @if (!isIframeMode) {
                <ptl-group-filter
                  class="filter-panel"
                  (filterDeleted)="onRemoveFilter('GROUP')"
                  (filterSaved)="onSaveFilter($event)"
                  [selectedFilters]="filters"
                  [playlistUid]="!isAdminPage() ? playlistUid() : undefined"
                ></ptl-group-filter>
              }
            }
            @case ('ROLE') {
              <ptl-role-filter
                class="filter-panel"
                (filterDeleted)="onRemoveFilter('ROLE')"
                (filterSaved)="onSaveFilter($event)"
                [selectedFilters]="filters"
              ></ptl-role-filter>
            }
            @case ('ATTENDANCE') {
              <ptl-attendance-filter
                class="filter-panel"
                (filterDeleted)="onRemoveFilter('ATTENDANCE')"
                (filterSaved)="onSaveFilter($event)"
                [selectedFilters]="filters"
                [isPlaylistPageAndTicketExist]="isPlaylistPage() && isTicketExist"
              ></ptl-attendance-filter>
            }
            @case ('ACTIVITY') {
              <ptl-activity-date-filter
                class="filter-panel"
                (filterDeleted)="onRemoveFilter('ACTIVITY')"
                (filterSaved)="onSaveFilter($event)"
                [selectedFilters]="filters"
              ></ptl-activity-date-filter>
            }
            @case ('COMPLETION') {
              <ptl-completion-filter
                class="filter-panel"
                (filterDeleted)="onRemoveFilter('COMPLETION')"
                (filterSaved)="onSaveFilter($event)"
                [selectedFilters]="filters"
                [isPlaylistPage]="isPlaylistPage()"
                [playlistUid]="playlistUid()"
                [isCardPage]="isCardPage()"
                [cardUid]="cardUid()"
                [cardHeaders]="cardHeaders()"
                [formHeaders]="formHeaders()"
              ></ptl-completion-filter>
            }
            @case ('REVIEW_STATUS') {
              <ptl-review-status-filter
                class="filter-panel"
                (filterDeleted)="onRemoveFilter('REVIEW_STATUS')"
                (filterSaved)="onSaveFilter($event)"
                [submissionMode]="getSubmissionMode"
                [selectedFilters]="filters"
              ></ptl-review-status-filter>
            }
          }
        </div>
      }
    </div>
  </div>
</div>
